module.exports = __webpack_public_path__ + "img/scen.c9e41feb.jpg";